import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import ReCaptchaV2 from "react-google-recaptcha";
import "./index.css";

import CustomSelect from "../FormComponents/CustomSelect";
import CustomInput from "../FormComponents/CustomInput";
import CustomTextArea from "../FormComponents/CustomTextArea";
import CustomRadioButton from "../FormComponents/CustomRadioButton";
import CustomRadioButtonTerms from "../FormComponents/CustomRadioButtonTerms";
import ContextForm from "./contextForm";

import CustomSelectDatePicker from "../FormComponents/CustomSelectDatePicker";
import CheckButton from "../FormComponents/CheckButton";
import arrow from "../../../../assets/images/svg_icons/arrow.svg";
import arrowWhite from "../../../../assets/images/svg_icons/arrowWhite.svg";
import warning from "../../../../assets/images/svg_icons/warning.svg";
import {
  postPublicFormData,
  postProfessionalDataForm,
} from "../../../../services/postFormData";

const ReportForm = (props) => {

  const { data, extras } = props;
  const [titleActive, setTitleActive] = useState(0);
  const [publicFormData, setPublicFormData] = useState({});
  const [professionalFormData, setProfessionalFormData] = useState({});
  const [isVisiblePopoverSendPublicForm, /* setIsVisiblePopoverSendPublicForm */] =
    useState(false);

  const handleOnChangePublicForm = (value, field) => {
    setPublicFormData({
      ...publicFormData,
      [field]: value,
    });
  };
  const handleOnChangeProfessionalForm = (value, field) => {
    setProfessionalFormData({
      ...professionalFormData,
      [field]: value,
    });
  };

  const [errorFieldsPublicForm, setErrorFieldsPublicForm] = useState(false);
  const [errorSentForm, setErrorSentForm] = useState('');
  const [successPublic, setSuccessPublic] = useState(false)
  const [successProfessional, setSuccessProfessional] = useState(false)
  const [errorFieldsProfessionalForm, setErrorFieldsProfessionalForm] = useState(false);

  const sendDataPublicForm = async () => {
    if (
      publicFormData.country &&
      publicFormData.name &&
      publicFormData.birth_date &&
      publicFormData.gender &&
      publicFormData.name_symptom &&
      publicFormData.onset_discomfort_date &&
      publicFormData.name_product_cause_discomfort &&
      publicFormData.initial_date_taking_product &&
      publicFormData.finish_date_taking_product &&
      publicFormData.suspended_product &&
      publicFormData.country !== "" &&
      publicFormData.name !== "" &&
      publicFormData.birth_date !== "" &&
      publicFormData.gender !== "" &&
      publicFormData.name_symptom !== "" &&
      publicFormData.onset_discomfort_date !== "" &&
      publicFormData.name_product_cause_discomfort !== "" &&
      publicFormData.initial_date_taking_product !== "" &&
      publicFormData.finish_date_taking_product !== "" &&
      publicFormData.suspended_product !== "" &&
      publicFormData.accepted_terms &&
      publicFormData.accepted_terms === true
    ) {
      try {
        const response = await postPublicFormData(publicFormData);
        setSuccessPublic(Boolean(response))
      } catch (error) {
        setErrorSentForm(error.toString())
      }


    } else {
      setErrorSentForm('Asegúrate de que todos los campos estén completos para poder continuar')
      setErrorFieldsPublicForm(true);
    }
  };

  const renderPublicForm = () => {
    if (extras.public === 'inactive') return null
    return !successPublic ? (
      <>
        <div className='form-title'>{data.public_form.title}</div>
        <div className='form-title'>Datos del paciente</div>
        <div
          className="form-text"
          style={{ marginTop: "0" }}
          dangerouslySetInnerHTML={{ __html: data.public_form.info }}
        />
        <div className="row-elements">
          <div className="element-form">
            <CustomSelect
              label={data.public_form.labels_form?.country}
              options={data.public_form.catalogs.country.options}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "country");
              }}
            />
          </div>
          <div className="element-form">
            <CustomInput
              label={data.public_form.labels_form?.name}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "name");
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelectDatePicker
              label={data.public_form.labels_form?.birth_date}
              // isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "birth_date");
              }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomRadioButton
              options={data.public_form.catalogs.gender.options}
              label={data.public_form.labels_form?.gender}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "gender");
              }}
            />
          </div>
          <div
            className="element-form"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "40%", height: "100%" }}>
              <CustomInput
                label={data.public_form.labels_form?.weight}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "weight");
                }}
                type="number"
              />
            </div>
            <div style={{ width: "40%", height: "100%" }}>
              <CustomInput
                label={data.public_form.labels_form?.measure}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "measure");
                }}
                type="number"
              />
            </div>
          </div>
          <div className="element-form"></div>
        </div>
        <div className="division-gray-line" />
        <div className="row-elements">
          <div className="element-form">
            <CustomInput
              label={data.public_form.labels_form?.name_symptom}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "name_symptom");
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelect
              label={data.public_form.labels_form?.select_symptom}
              options={data.public_form.catalogs.symptom.options}
              onChange={(value) => {
                handleOnChangePublicForm(value, "recover_symptom");
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelectDatePicker
              label={data.public_form.labels_form?.symptom_date}
              // isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "onset_discomfort_date");
              }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomInput
              label={data.public_form.labels_form?.medicine}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(
                  value,
                  "name_product_cause_discomfort"
                );
              }}
              setDisabledButton={() => { }}
            />
          </div>

          <div
            className="element-form"
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "space-between",
              position: "relative",
            }}
          >
            <label className={"label"} style={{}}>
              {data.public_form.labels_form?.medicine_date}
              {/* <span>*</span> */}
            </label>
            <div className='medicine_date'>
              <div className='medicine_date_item'>
                <CustomSelectDatePicker
                  label={data.public_form.labels_form.date_start}
                  labelClass="custom-label-date-picker"
                  onChange={(value) => {
                    handleOnChangePublicForm(
                      value,
                      "initial_date_taking_product"
                    );
                  }}
                  // isRequired
                  setDisabledButton={() => { }}
                />
              </div>
              <div className='medicine_date_item'>
                <CustomSelectDatePicker
                  label={data.public_form.labels_form.date_finish}
                  labelClass="custom-label-date-picker"
                  onChange={(value) => {
                    handleOnChangePublicForm(
                      value,
                      "finish_date_taking_product"
                    );
                  }}
                  // isRequired
                  setDisabledButton={() => { }}
                />
              </div>
            </div>
          </div>
          <div className="element-form">
            <CustomRadioButton
              options={data.public_form.catalogs.medicine_radio.options}
              label={data.public_form.labels_form?.medicine_radio}
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "suspended_product");
              }}
              setDisabledButton={() => { }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomRadioButton
              options={
                data.public_form.catalogs.secundary_medicine_radio.options
              }
              label={
                data.public_form.labels_form?.secundary_medicine_name
              }
              onChange={(value) => {
                handleOnChangePublicForm(value, "take_another_product");
              }}
              setDisabledButton={() => { }}
            />
          </div>
          <div className="element-form">
            <CustomInput
              label={
                data.public_form.labels_form?.tertiary_medicine_recommend
              }
              onChange={(value) => {
                handleOnChangePublicForm(value, "name_another_product");
              }}
              setDisabledButton={() => { }}
            />
          </div>
          <div className="element-form">
            <CustomSelect
              label={
                data.public_form.labels_form?.secundary_medicine_recommend
              }
              options={
                data.public_form.catalogs.secundary_medicine_recommend
                  .options
              }
              onChange={(value) => {
                handleOnChangePublicForm(
                  value,
                  "who_suggest_another_product"
                );
              }}
              setDisabledButton={() => { }}
            />
          </div>
        </div>
        <div className="division-gray-line" />
        <div className="aditional-info">
          <div
            className="title-definition"
            style={{ marginBottom: "1vh" }}
          >
            {data.public_form.labels_form.report_reaction_label}
          </div>
          <div className="element-form">
            <CustomRadioButton
              options={
                data.public_form.catalogs.secundary_medicine_radio.options
              }
              label={
                data.public_form.labels_form?.contact_question
              }
              isRequired
              onChange={(value) => {
                handleOnChangePublicForm(value, "contact_question");
              }}
              setDisabledButton={() => { }}
            />
          </div>
          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={data.public_form.labels_form?.phone}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "phone");
                }}
                type="tel"
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.public_form.labels_form?.cell_phone}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "cell_phone");
                }}
                type="tel"
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.public_form.labels_form?.email}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "email");
                }}
                type="email"
              />
            </div>
          </div>

          <div className="row-elements">
            <div className="element-form textarea-comments" style={{ width: "60%" }}>
              <CustomTextArea
                label={data.public_form.labels_form?.comments}
                onChange={(value) => {
                  handleOnChangePublicForm(value, "comments");
                }}
              />
            </div>
            <div className="element-form">
              <CustomRadioButtonTerms
                keyword_term={data.keyword_term}
                term={data.term}
                isRequired
                onChange={(value) => {
                  handleOnChangePublicForm(value, "accepted_terms");
                }}
                setDisabledButton={() => { }}
              />
            </div>
          </div>

          <div className="final-row-elements">

          </div>
          <p style={{ color: 'crimson' }}>{errorSentForm}</p>
          <div className="final-row-elements">
            <ReCaptchaV2 sitekey={props.general.recaptcha_public_v2} />
          </div>
          <div className="final-row-elements">
            <div
              className="report-button"
              onClick={() => {
                sendDataPublicForm();
              }}
            >
              {data.title_send_button}
              <img className='arrow-left' src={arrowWhite} alt='flecha' />
            </div>
          </div>
        </div>
      </>
    )
      : <div className='contact__form-loader'>
        <p dangerouslySetInnerHTML={{ __html: extras.thanks }} />
        <img src={extras.logo} alt='SANFER LOGO' />
      </div>

  }

  const renderProfessionalForm = () => {
    if (extras.professional === 'inactive') return null
    return !successProfessional ? (
      <>
        <div className='form-title'>{data.professional_form.title}</div>
        <div className='form-title'>Datos del paciente</div>
        <div
          style={{ marginTop: "0" }}
          dangerouslySetInnerHTML={{
            __html: data.professional_form.info,
          }}
        />
        <div className="row-elements">
          <div className="element-form">
            <CustomSelect
              label={data.professional_form.labels_form?.country}
              options={data.professional_form.catalogs.country.options}
              isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "country");
              }}
            />
          </div>
          <div className="element-form">
            <CustomInput
              label={data.professional_form.labels_form?.name}
              isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "name");
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelectDatePicker
              label={data.professional_form.labels_form?.birth_date}
              // isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "birth_date");
              }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomRadioButton
              options={data.professional_form.catalogs.gender.options}
              label={data.professional_form.labels_form?.gender}
              isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "gender");
              }}
            />
          </div>
          <div
            className="element-form"
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
            }}
          >
            <div style={{ width: "45%" }}>
              <CustomInput
                label={data.professional_form.labels_form?.weight}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "weight");
                }}
                type={"number"}
              />
            </div>
            <div style={{ width: "45%" }}>
              <CustomInput
                label={data.professional_form.labels_form?.measure}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "measure");
                }}
                type={"number"}
              />
            </div>
          </div>
          <div className="element-form"></div>
        </div>
        <div className="division-gray-line" />
        <div className="row-elements">
          <div className="element-form" style={{ width: "65%" }}>
            <CustomTextArea
              label={data.professional_form.labels_form?.description_sram}
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "description_sram");
              }}
              isRequired
            />
          </div>
          <div className="element-form">
            <CustomRadioButton
              options={
                data.professional_form.catalogs.type_prescription.options
              }
              label={
                data.professional_form.labels_form?.type_prescription
              }
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "type_prescription"
                );
              }}
              vertical
            />
          </div>
        </div>

        <div className="row-elements">
          <div
            className="element-form row-input"
          >
            <label
              className={"label input-title bold"}
            >
              {data.professional_form.labels_form?.date_sram}
              {/* <span>*</span> */}
            </label>

            <div className='input-container'>
              <CustomSelectDatePicker
                label={data.professional_form.labels_form?.date_start}
                labelClass="custom-label-date-picker"
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "initial_date_SRAM"
                  );
                }}
                // isRequired
              />
              <CustomSelectDatePicker
                label={data.professional_form.labels_form?.date_finish}
                labelClass="custom-label-date-picker"
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "finish_date_SRAM");
                }}
                isRequired
              />
            </div>
          </div>
          <div className="element-form">
            <CustomSelect
              label={
                data.professional_form.labels_form?.question_suspended
              }
              options={
                data.professional_form.catalogs.question_suspended.options
              }
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "suspended_medicine_due_sram"
                );
              }}
            />
          </div>

          <div className="element-form">
            <CustomSelect
              label={
                data.professional_form.labels_form?.question_improvement
              }
              options={
                data.professional_form.catalogs.question_improvement
                  .options
              }
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "improvement_when_suspending"
                );
              }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomSelect
              label={
                data.professional_form.labels_form?.administer_medication
              }
              options={
                data.professional_form.catalogs.administer_medication
                  .options
              }
              // isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "readminister_medicine_due_sram"
                );
              }}
            />
          </div>

          <div className="element-form">
            <CustomSelect
              label={data.professional_form.labels_form?.present_sram}
              options={
                data.professional_form.catalogs.present_sram.options
              }
              // isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "present_again_sram"
                );
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelect
              label={data.professional_form.labels_form?.decrease_dose}
              options={
                data.professional_form.catalogs.decrease_dose.options
              }
              // isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "decrease_dose_medicine"
                );
              }}
            />
          </div>
        </div>
        <div className="row-elements">
          <div className="element-form">
            <CustomSelect
              label={data.professional_form.labels_form?.recover_sram}
              options={
                data.professional_form.catalogs.recover_sram.options
              }
              isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(value, "recover_of_sram");
              }}
            />
          </div>
          <div className="element-form">
            <CustomRadioButton
              label={
                data.professional_form.labels_form?.change_pharmacotherapy
              }
              options={
                data.professional_form.catalogs.change_pharmacotherapy
                  .options
              }
              isRequired
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "change_pharmacotherapy"
                );
              }}
            />
          </div>
          <div className="element-form">
            <CustomSelect
              label={
                data.professional_form.labels_form?.take_medicine_sram
              }
              options={
                data.professional_form.catalogs.take_medicine_sram.options
              }
              onChange={(value) => {
                handleOnChangeProfessionalForm(
                  value,
                  "medicine_treat_sram"
                );
              }}
            />
          </div>
        </div>
        <div className="division-gray-line" />
        <div className="aditional-info">
          <div
            className="title-definition"
            style={{ marginBottom: "1vh" }}
          >
            {data.professional_form.labels_form?.data_medicine_suspicious}
          </div>
          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.tradename}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "suspicious_medicine_name"
                  );
                }}
                isRequired
              />
            </div>

            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.generic_name}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "suspicious_generic_name"
                  );
                }}
                // isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={
                  data.professional_form.labels_form?.pharmaceutical_form
                }
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "pharmaceutical_form"
                  );
                }}
              />
            </div>
          </div>

          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={
                  data.professional_form.labels_form?.route_administration
                }
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "route_administration"
                  );
                }}
                isRequired
              />
            </div>

            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.lot_number}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "lot_number");
                }}
                // isRequired
              />
            </div>
            <div className="element-form">
              <CustomSelectDatePicker
                label={
                  data.professional_form.labels_form?.expiration_date
                }
                // isRequired
                futureYearsLimit={extras.limit_year_expiration}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "expiration_date"
                  );
                }}
              />
            </div>
          </div>

          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.what_disease}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "what_disease");
                }}
                // isRequired
              />
            </div>

            <div
              className="element-form"
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-around",
                position: "relative",
              }}
            >
              <CustomSelectDatePicker
                label={data.professional_form.labels_form?.date_start}
                labelClass="custom-label-date-picker"
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "initial_date_medicine_suspicious"
                  );
                }}
                // isRequired
              />
              <CustomSelectDatePicker
                label={data.professional_form.labels_form?.date_finish}
                labelClass="custom-label-date-picker"
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "finish_date_medicine_suspicious"
                  );
                }}
                // isRequired
              />
            </div>
            <div className="element-form"></div>
          </div>

          <div className="division-gray-line" />

          <div
            className="title-definition"
            style={{ marginBottom: "1vh" }}
          >
            {data.public_form.labels_form?.dose_took_label}
          </div>

          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.dose}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "dose");
                }}
                // isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.schedule}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "schedule");
                }}
                // isRequired
              />
            </div>

            <div className="element-form">
              <CustomRadioButton
                options={
                  data.professional_form.catalogs.other_treatment.options
                }
                label={
                  data.professional_form.labels_form?.other_treatment
                }
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "other_treatment"
                  );
                }}
              />
            </div>
          </div>

          <div className="row-elements">
            <div className="element-form">
              <CustomRadioButton
                options={
                  data.professional_form.catalogs.allergies.options
                }
                label={data.professional_form.labels_form?.allergies}
                // isRequired
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "allergies");
                }}
              />
            </div>
            <div className="element-form" style={{ width: "65%" }}>
              <CustomTextArea
                label={
                  data.professional_form.labels_form?.which_allergies
                }
                // isRequired
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "which_allergies"
                  );
                }}
              />
            </div>
          </div>
          <div className="row-elements">
            <div className="element-form">
              <CheckButton
                options={
                  data.professional_form.catalogs.conditions.options
                }
                label={data.professional_form.labels_form?.conditions}
                // isRequired
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    JSON.stringify(value),
                    "conditions"
                  );
                }}
              />
            </div>
            <div
              className="element-form"
              style={{ width: "65%", height: "100%" }}
            >
              <CustomTextArea
                label={
                  data.professional_form.labels_form?.data_clinic_history
                }
                rows={18}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "relevant_patient_data"
                  );
                }}
              />
            </div>
          </div>
        </div>
        <div className="division-gray-line" />
        <div className="aditional-info">
          <div
            className="title-definition"
            style={{ marginBottom: "1vh" }}
          >
            {data.professional_form.labels_form?.data_professional}
          </div>

          <div className="row-elements">
            <div className="element-form">
              <CustomInput
                label={
                  data.professional_form.labels_form?.name_professional
                }
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "name_professional"
                  );
                }}
                isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.last_name}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "last_name_professional"
                  );
                }}
                isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.first_name}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(
                    value,
                    "first_name_professional"
                  );
                }}
              />
            </div>
          </div>
          <div className="row-elements">
            <div className="element-form flex-row">
              <CustomInput
                label={data.professional_form.labels_form?.lada}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "lada");
                }}
                className='small-input'
                // isRequired
              />
              <CustomInput
                label={data.professional_form.labels_form?.phone}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "phone");
                }}
                // isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.cell_phone}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "cell_phone");
                }}
                // isRequired
              />
            </div>
            <div className="element-form">
              <CustomInput
                label={data.professional_form.labels_form?.email}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "email");
                }}
                // isRequired
              />
            </div>
          </div>

          <div className="row-elements" style={{}}>
            <div className="element-form">
              <CustomInput
                label={data.public_form.labels_form?.alternate_email}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "alternate_email");
                }}
                // isRequired
              />
            </div>

            <div className="element-form">
              <CustomRadioButton
                options={
                  data.public_form.catalogs.secundary_medicine_radio.options
                }
                label={
                  data.public_form.labels_form?.contact_question
                }
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "contact_question");
                }}
                setDisabledButton={() => { }}
                isRequired
              />
            </div>

            <div className="element-form" >
              <CustomTextArea
                label={data.professional_form.labels_form?.comments}
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "comments");
                }}
              />

              <CustomRadioButtonTerms
                keyword_term={data.keyword_term}
                term={data.term}
                isRequired
                onChange={(value) => {
                  handleOnChangeProfessionalForm(value, "accepted_terms");
                }}
              />
            </div>

          </div>
          <p style={{ color: 'crimson' }}>{errorSentForm}</p>
          <div className="final-row-elements">
            <ReCaptchaV2 sitekey={props.general.recaptcha_public_v2} />
          </div>
          <div className="final-row-elements">
            <div
              className="report-button"
              onClick={() => {
                sendDataProfessionalForm();
              }}
            >
              {data.title_send_button}
              <img className='arrow-left' src={arrowWhite} alt='flecha' />
            </div>
          </div>
        </div>
      </>
    )
      : <div className='contact__form-loader'>
        <p dangerouslySetInnerHTML={{ __html: extras.thanks }} />
        <img src={extras.logo} alt='SANFER LOGO' />
      </div>
  }


  // eslint-disable-next-line
  const sendDataProfessionalForm = async () => {
    setErrorFieldsProfessionalForm(false);
    if (
      professionalFormData.country &&
      professionalFormData.name &&
      professionalFormData.birth_date &&
      professionalFormData.gender &&
      professionalFormData.description_sram &&
      professionalFormData.initial_date_SRAM &&
      professionalFormData.finish_date_SRAM &&
      professionalFormData.readminister_medicine_due_sram &&
      professionalFormData.present_again_sram &&
      professionalFormData.decrease_dose_medicine &&
      professionalFormData.recover_of_sram &&
      professionalFormData.change_pharmacotherapy &&
      professionalFormData.suspicious_medicine_name &&
      professionalFormData.suspicious_generic_name &&
      professionalFormData.route_administration &&
      professionalFormData.lot_number &&
      professionalFormData.expiration_date &&
      professionalFormData.what_disease &&
      professionalFormData.dose &&
      professionalFormData.schedule &&
      professionalFormData.allergies &&
      professionalFormData.name_professional &&
      professionalFormData.last_name_professional &&
      professionalFormData.cell_phone &&
      professionalFormData.email &&
      professionalFormData.conditions
    ) {
      try {
        let payload = {
          // no requireds
          readminister_medicine_due_sram: 'N/D',
          medicine_treat_sram: 'N/D',
          weight: 0,
          measure: 0,
          type_prescription: 'N/D',
          suspended_medicine_due_sram: 'N/D',
          improvement_when_suspending: 'N/D',
          pharmaceutical_form: 'N/D',
          other_treatment: 'N/D',
          which_allergies: 'N/D',
          conditions: 'N/D',
          relevant_patient_data: 'N/D',
          first_name_professional: 'N/D',
          phone: 'N/D',
          comments: 'N/D',
          accepted_terms: 'N/D',
          ...professionalFormData
        }
        const response = await postProfessionalDataForm(payload);
        setSuccessProfessional(true)
        console.log(response)
      } catch (error) {
        console.log('error', error)
        setErrorSentForm(error.toString())
      }
    } else {
      setErrorFieldsProfessionalForm(true);
      setErrorSentForm('Asegúrate de que todos los campos estén completos para poder continuar')
    }
  };

  useEffect(() => {
    if (extras.public === 'inactive') setTitleActive(1);
    return () => { };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!Boolean(props.general.recaptcha_public_v2)) return null

  return (
    <ContextForm.Provider
      value={{ errorFieldsPublicForm, errorFieldsProfessionalForm }}
    >
      <div className="section-form">
        <div className="title-definition">{data.title}</div>

        <div className='title-description' dangerouslySetInnerHTML={{ __html: data.info }}></div>
        <div className="titles-commitment-report" style={{}}>
          {
            extras.public !== 'inactive' &&
            <div
              className={`${titleActive === 0 ? "title-active" : ""}`}
              onClick={() => {
                setTitleActive(0);
              }}
            >
              Público en general
            </div>
          }
          {
            extras.professional !== 'inactive' &&
            <div
              className={`${titleActive === 1 ? "title-active" : ""}`}
              onClick={() => {
                setTitleActive(1);
              }}
            >
              Profesional de la salud
            </div>
          }
        </div>
        <div className="container-form">
          {
            titleActive === 0 && renderPublicForm()
          }
          {
            titleActive === 1 && renderProfessionalForm()
          }

          <div
            className="confirm-send-data"
            style={{
              display: isVisiblePopoverSendPublicForm ? "none" : "none",
            }}
          >
            <div className="confirm" onClick={() => { }}>
              Confirmar
            </div>
            <div className="close">Cerrar</div>
          </div>


          <div className="row-elements">
            <p className="element-pleca">
              <img src={warning} alt="warning" />
              <div style={{ display: 'inline-block' }} dangerouslySetInnerHTML={{ __html: extras.footer }} />
            </p>
          </div>

          <div className="go_up">
            <a href="#top">Volver arriba</a>
            <img src={arrow} alt="arrow" />
          </div>
        </div>
      </div>

    </ContextForm.Provider>
  );
};

const mapStateToProps = (state) => ({
  settings: state.settings,
  general: state.general
});

export default connect(mapStateToProps)(ReportForm);
